<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servType')}}
												</label>
												<select v-model="instance.servType" class="form-control" multiple>
													<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id">
													{{ servType.typeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servCategory')}}
												</label>
												<select v-model="instance.servCategory" class="form-control" multiple>
													<option v-for="servCategory in servCategoryList" :value="servCategory.id" :key="servCategory.id">
													{{ servCategory.categoryName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servService')}}
												</label>
												<select v-model="instance.servService" class="form-control" multiple>
													<option v-for="servService in servServiceList" :value="servService.id" :key="servService.id">
													{{ servService.serviceName}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.qteSup', { obj: $t(instanceClassAttr.instanceClass+'.stock')} )}}</label>
												<input type="number" v-model="instance.qteSup" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.qteInf', { obj: $t(instanceClassAttr.instanceClass+'.stock')} )}}</label>
												<input type="number" v-model="instance.qteInf" class="form-control" />
											</div>
										</div>

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	// import modalScriptMixin from "@/mixins/modalScriptMixin";
	export default {
		name: 'servTypeServ',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('servtypeserv.label'),
				pageTitle: this.$t('servtypeserv.list'),
				pageIcon: 'window-restore',
				instanceClassAttr: {
					instanceClass: 'servtypeserv',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '15%', 
						actAdd: true, 
						actGet: false, 
						actEdit: false, 
						actDel: false,
						actPrint: 'produce'
					},
					attrsList: [
					
						{attrName: 'servTypeLib', attrCol: '25%', searchable: false, sortable: true},
						{attrName: 'servServiceLib', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'stock', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'amount', attrCol: '15%', searchable: false, sortable: true, attrRep: 'getAmountStr()'},
						{attrName: 'lastUpdated', attrCol: '15%', searchable: true, sortable: false}
						// {attrName: 'MontantE', attrCol: '20%', searchable: true, sortable: false}
					]
				},
				instance: {
					servType: [],
					servCategory: [],
					servService: [],
					qteSup: '',
					qteInf: ''
				},
				// prsStoreList: [],
				servTypeList: [],
				servCategoryList: [],
				servServiceList: [],
				
				chartOptions: {
					title: 'Statistique des stocks par ',
					hAxis: {title: 'Article / Produit'},
					vAxis: {title: 'Stock'},
					recap: {title: 'Stocks totaux', val:0}
				},
				chartData: [],
				typeStats: [
					{id: 'servType', label: this.$t('servtype.label')},
					{id: 'servService', label: this.$t('servservice.label')},
					{id: 'servCategory', label: this.$t('servcategory.label')},
				],
				typeStat: 'servType',
			
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				/*await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})*/
				
				// GET LIST servTypeList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtype'
				})
				.then(response => {
					this.servTypeList = response.data
				})
				.catch(error => {
					console.log('error catch servTypeList == ', error.message)
				})
				
				// GET LIST servCategoryList
				await this.$store.dispatch('axiosGet', {
					domain: 'servcategory'
				})
				.then(response => {
					this.servCategoryList = response.data
				})
				.catch(error => {
					console.log('error catch servcategory == ', error.message)
				})
				// GET LIST servServiceList
				await this.$store.dispatch('axiosGet', {
					domain: 'servservice'
				})
				.then(response => {
					this.servServiceList = response.data

					if(!this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
						let serviceCode = ''
						if(this.$store.getters.isAuthorized(['ROLE_PROD']))
							serviceCode = 'P'
						else if(this.$store.getters.isAuthorized(['ROLE_STOCK']))
							serviceCode = 'S'
						if(this.$store.getters.isAuthorized(['ROLE_VENTE']))
							serviceCode = 'V'
						this.servServiceList = this.servServiceList.filter(item => item.serviceCode == serviceCode)
						this.instance.servService.push(this.servServiceList[0].id)
						if(this.$store.getters.isAuthorized(['ROLE_STOCK'])){

							this.servCategoryList = this.servCategoryList.filter(item => item.categoryCode == 'ART')
							this.instance.servCategory.push(this.servCategoryList[0].id)

						}
					}
					
				})
				.catch(error => {
					console.log('error catch servServiceList == ', error.message)
				})
				this.search()
			}
			// this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					// prsStore: [],
					servType: [],
					servService: [],
					servCategory: [],
					qteSup: '',
					qteInf: ''
				};
			},
			async search() {
				let strParamsForms = "";
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				strParamsForms = strParamsForms+"&params1=servType.id&valParams1="+this.instance.servType +"&logParams1=inL"
				if(this.instance.servType && this.instance.servType.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servTypeList, this.instance.servType, 'typeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servType')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&aliasList=_servType"
				strParamsForms = strParamsForms+"&params2=servService.id&valParams2="+this.instance.servService +"&logParams2=inL"
				if(this.instance.servService && this.instance.servService.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servServiceList, this.instance.servService, 'serviceName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servService')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&params3=_servType.servCategory.id&valParams3="+this.instance.servCategory +"&logParams3=inL"
				if(this.instance.servCategory && this.instance.servCategory.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servCategoryList, this.instance.servCategory, 'categoryName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servCategory')+'(s) : </i><b>'+strLibs + '</b>'
				}
				// Qte super
				strParamsForms = strParamsForms+"&params4=stock&valParams4="+this.instance.qteSup+"&logParams4=geI"
				if(this.instance.qteSup !== ''){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.stock')+' >= </i><b>'+this.$store.getters.formatNumber(this.instance.qteSup) + '</b>'
				}
				// Qte inf
				strParamsForms = strParamsForms+"&params5=stock&valParams5="+this.instance.qteInf+"&logParams5=leI"
				if(this.instance.qteInf !== ''){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.stock')+' <;= </i><b> '+this.$store.getters.formatNumber(this.instance.qteInf) + '</b>'
				}
				
				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				// strParamsForms
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Type", "Quantité par Type"] 
				let attrKey = 'servTypeLib'
				let attrValue = 'stock'
				if(this.typeStat === 'servType' )
					attrKey = 'servTypeLib'
				else if(this.typeStat === 'servService' ){
					// statLabel = ["Service", "Quantité par Service"]
					this.chartOptions.title = 'Statistique des montant par '
					this.chartOptions.hAxis.title = 'Service'
					this.chartOptions.vAxis.title = 'Montant'
					this.chartOptions.recap.title = 'Montant totaux'

					statLabel = ["Service", "Montant par Service"]
					attrValue = 'amount'
					attrKey = 'servServiceLib'
				}
				else if(this.typeStat === 'servCategory' ){
					this.chartOptions.hAxis.title = 'Catégorie'
					statLabel = ["Catégorie", "Quantité par Catégorie"]
					attrKey = 'servCategoryLib'
				}
				
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				let sumData = 0;
				dataList?.forEach(data => {
					this.chartData.push(data);
					sumData = sumData + data[1]
				});
				if(attrValue == 'amount')
					this.chartOptions.recap.val = this.$store.getters.formatAmount(sumData)
				else
					this.chartOptions.recap.val = this.$store.getters.formatNumber(sumData)
				if(this.chartOptions.recap.title && this.chartOptions.recap.val){
					let detailsBot = '&detailsBot=<i> '+ this.chartOptions.recap.title +' : <b> '+ this.chartOptions.recap.val +'</b> </i>';
					this.$refs.componentDatatableInstance.addStrParamsForms(detailsBot);
				}
			},
			
		}
		
	}

</script>